/*
 * @Author: M.D.
 * @Date: 2019-12-27 10:07:32
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */

// 类似金钱,首位不为0,最多2位小数
export function checkNumPot2(rule, value, cb) {
  const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
  if (!value) {
    return cb(new Error('请填写数字'))
  } else if (!reg.test(value)) {
    return cb(new Error('请填写数字,最多2位小数'))
  } else {
    cb()
  }
}

// 身份证
export function checkIdNum(rule, value, cb) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if (!value) {
    return cb(new Error('证件号码不能为空'))
  } else if (!reg.test(value)) {
    return cb(new Error('证件号码不正确'))
  } else {
    cb()
  }
}

// 整数
export function checkInterNum(rule, value, cb) {
  const reg = /^[0-9]*[1-9][0-9]*$/
  if (!value) {
    return cb(new Error('请填写整数'))
  } else if (!reg.test(value)) {
    return cb(new Error('请输入整数'))
  } else {
    cb()
  }
}

// 用户名验证(6-20 非纯数字)
export const usrName = (rule, value, cb) => {
  // const reg = /^(\w?[a-zA-Z]\w?)|(_\d)|(\d_){6,20}$/
  // const reg = /^[\x21-\x7E]{6,20}$|^((\s+$))/
  const reg = /^[\s\S]{6,20}$/
  const reg1 = /^[0-9]*$/
  if (!value) {
    return cb(new Error('用户名不能为空'))
  } else if (!reg.test(value)) {
    return cb(new Error('请输入6-20位非纯数字字符'))
  } else if (reg1.test(value)) {
    return cb(new Error('请输入6-20位非纯数字字符'))
  } else {
    cb()
  }
}

// 收货人
export const consignee = (rule, value, cb) => {
  const reg = /^.{1,20}$/
  if (!value) {
    return cb(new Error('收货人不能为空'))
  } else if (!reg.test(value)) {
    return cb(new Error('请输入1-20位字符'))
  } else {
    cb()
  }
}
// 密码验证（6-20）
export const pwd = (rule, value, cb) => {
  const reg = /^[A-Za-z0-9]{6,20}$/
  if (!value) {
    return cb(new Error('密码不能为空'))
  } else if (!reg.test(value)) {
    return cb(new Error('请输入6-20位字符'))
  } else {
    cb()
  }
}

// 重复密码
export const repPwd = (rule, value, cb) => {
  const reg = /^.{6,20}$/
  if (!value) {
    return cb(new Error('确认密码不能为空'))
  } else if (!reg.test(value)) {
    return cb(new Error('请输入6-20位字符'))
  } else {
    cb()
  }
}

// 空值验证
export const required = (rule, value, cb) => {
  if (!value) {
    return cb(new Error('此处不能为空'))
  } else {
    cb()
  }
}

// 手机
export const phone = (rule, value, cb) => {
  const reg = /^1[3456789]\d{9}$/
  if (!value) {
    return cb(new Error('手机号码不能为空'))
  } else if (!reg.test(value)) {
    return cb(new Error('请输入正确的手机号码'))
  } else {
    cb()
  }
}

// 地区
export const region = (rule, value, cb) => {
  console.log(value)
  if (!value) {
    return cb(new Error('地区不能为空'))
  } else if (value.length !== 3) {
    return cb(new Error('请选择省-市-区'))
  } else {
    cb()
  }
}

// 0-20位字符
export const word20 = (rule, value, cb) => {
  const reg = /^.{0,20}$/
  if (value && !reg.test(value)) {
    return cb(new Error('请输入0-20位字符'))
  } else {
    cb()
  }
}

// 详细地址
export const addressDetail = (rule, value, cb) => {
  const reg = /^.{5,120}$/
  if (!value) {
    return cb(new Error('详细地址不能为空'))
  } else if (value && !reg.test(value)) {
    return cb(new Error('请输入5-120位字符'))
  } else {
    cb()
  }
}

// 0-12位字符
export const word12 = (rule, value, cb) => {
  const reg = /^.{0,12}$/
  if (value && !reg.test(value)) {
    return cb(new Error('请输入0-12位字符'))
  } else {
    cb()
  }
}

// 发票抬头
export const invoiceRise = (rule, value, cb) => {
  const reg = /^.{1,50}$/
  if (!value) {
    return cb(new Error('发票抬头不能为空'))
  } else if (!reg.test(value)) {
    return cb(new Error('请输入1-50位字符'))
  } else {
    cb()
  }
}

// 企业名称
export const companyName = (rule, value, cb) => {
  const reg = /^.{1,50}$/
  if (!value) {
    return cb(new Error('企业名称不能为空'))
  } else if (!reg.test(value)) {
    return cb(new Error('请输入1-50位字符'))
  } else {
    cb()
  }
}

// 纳税人识别号
export const taxpayerNumber = (rule, value, cb) => {
  const reg = /^.{1,20}$/
  if (!value) {
    return cb(new Error('纳税人识别号不能为空'))
  } else if (!reg.test(value)) {
    return cb(new Error('请输入1-20位字符'))
  } else {
    cb()
  }
}

// 纳税人识别号
export const taxpayerNumberNotRequired = (rule, value, cb) => {
  const reg = /^.{1,20}$/
  if (value && !reg.test(value)) {
    return cb(new Error('请输入最多20个字符'))
  } else {
    cb()
  }
}

// 邮箱
export const email = (rule, value, cb) => {
  const reg = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
  const num = /^.{1,32}$/
  if (!value) {
    return cb(new Error('邮箱不能为空'))
  } else if (!num.test(value)) {
    return cb(new Error('请输入1-32个字符'))
  } else if (!reg.test(value)) {
    return cb(new Error('邮箱格式错误'))
  } else {
    cb()
  }
}

// 0-100位字符
export const word100 = (rule, value, cb) => {
  const reg = /^.{0,100}$/
  if (value && !reg.test(value)) {
    return cb(new Error('请输入0-100位字符'))
  } else {
    cb()
  }
}


export default {
  usrName: [{
    required: true,
    validator: usrName,
    trigger: 'blur'
  }],
  phone: [{
    required: true,
    validator: phone,
    trigger: 'blur'
  }],
  required: [{
    required: true,
    validator: required,
    trigger: 'blur'
  }],
  pwd: [{
    required: true,
    validator: pwd,
    trigger: 'blur'
  }],
  repPwd: [{
    required: true,
    validator: repPwd,
    trigger: 'blur'
  }],
  InterNum: [{
    required: true,
    validator: checkInterNum,
    trigger: 'blur'
  }],
  region: [{
    required: true,
    validator: region,
    trigger: 'blur'
  }],
  word100: [{
    required: false,
    validator: word100,
    trigger: 'blur'
  }],
  word12: [{
    required: false,
    validator: word12,
    trigger: 'blur'
  }],
  word20: [{
    required: false,
    validator: word20,
    trigger: 'blur'
  }],
  invoiceRise: [{
    required: true,
    validator: invoiceRise,
    trigger: 'blur'
  }],
  email: [{
    required: true,
    validator: email,
    trigger: 'blur'
  }],
  taxpayerNumberRequired: [{
    required: true,
    validator: taxpayerNumber,
    trigger: 'blur'
  }],
  taxpayerNumberNotRequired: [{
    required: false,
    validator: taxpayerNumberNotRequired,
    trigger: 'blur'
  }],
  companyName: [{
    required: true,
    validator: companyName,
    trigger: 'blur'
  }],
  consignee: [{
    required: true,
    validator: consignee,
    trigger: 'blur'
  }],
  addressDetail: [{
    required: true,
    validator: addressDetail,
    trigger: 'blur'
  }],
}
